function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.1429 13.9091H37.4551C37.7564 13.9091 38 14.1533 38 14.4545C38 14.7558 37.7558 15 37.4545 15H30.5455C30.2442 15 30 14.7558 30 14.4545C30 14.1533 30.2437 13.9091 30.5449 13.9091H32.8571C33.5528 13.9091 33.7143 10.3636 33.4286 10.3636H32.0729C31.6963 10.3636 31.3913 10.0584 31.3913 9.68182C31.3913 9.30526 31.6966 9 32.0731 9H35.8896C36.2662 9 36.5714 9.30526 36.5714 9.68182C36.5714 10.0584 36.2665 10.3636 35.8899 10.3636H34.5714C34.2857 10.3636 34.6791 13.9091 35.1429 13.9091Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.14286 13.9091H7.45514C7.75639 13.9091 8 14.1533 8 14.4545C8 14.7558 7.75579 15 7.45455 15H0.545455C0.244208 15 0 14.7558 0 14.4545C0 14.1533 0.243688 13.9091 0.544934 13.9091H2.85714C3.5528 13.9091 3.71429 10.3636 3.42857 10.3636H2.07285C1.6963 10.3636 1.3913 10.0584 1.3913 9.68182C1.3913 9.30526 1.69656 9 2.07312 9H5.88961C6.26617 9 6.57143 9.30526 6.57143 9.68182C6.57143 10.0584 6.26645 10.3636 5.88989 10.3636H4.57143C4.28571 10.3636 4.67909 13.9091 5.14286 13.9091Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 9L13.5768 7.50571L9.49429 3.42322L8 9ZM15.6464 0.646447L10.8284 5.46447L11.5355 6.17157L16.3536 1.35355L15.6464 0.646447Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 10,
  y1: 14.5,
  x2: 28,
  y2: 14.5,
  stroke: "white"
});

var SvgLeftInnerButton = function SvgLeftInnerButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 15,
    viewBox: "0 0 38 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeftInnerButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LeftInnerButton.657e4e52.svg";
export { ForwardRef as ReactComponent };